<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="custom-container">
        <div class="row mb-3">
            <div class="col d-flex justify-content-center align-items-center">
                <div>
                    <img @click="$emit('clear-event-types'); $emit('go-to-event', 'ToWhomScreenId')" class="me-5 cursor-pointer" src="../../assets/project-screen/vertical-button.svg" width="150" alt="">
                </div>
                <h1 @click="$emit('clear-event-types'); $emit('go-to-event', 'ToWhomScreenId')" class="thin-text mb-5 fs-2 cursor-pointer">Progetto per un proprio caro</h1>
            </div>
        </div>
        <div class="row mb-3" style="position: relative; top: -50px; left: -20px;">
            <div class="col d-flex justify-content-center align-items-center">
                <div>
                    <img @click="$emit('clear-event-types'); $emit('go-to-event', 'ToWhomSelfScreenId')" class="me-5 cursor-pointer" src="../../assets/project-screen/vertical-button.svg" width="150" alt="">
                </div>
                <h1 @click="$emit('clear-event-types'); $emit('go-to-event', 'ToWhomSelfScreenId')" class="thin-text mb-5 fs-2 cursor-pointer">Progetto per te stesso</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PathSelectionScreen',
        emits: ['go-to-event', 'go-back-event', 'clear-event-types'],
    }
</script>